(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faqs-and-copy"] && !Shopify.designMode) return;
  try {
    
  //FAQs Accordion
var acc = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs-and-copy"] && !Shopify.designMode) return;
  try {
    
// FAQs Accordion (keep this at root level)
var acc = document.getElementsByClassName("faqs-accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
